export default __webpack_public_path__ + "static/media/auditor.cf2ffcd1.png";